import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import Button from '../global/Button';
import TrashIcon from '../icons/TrashIcon';
import FolderIcon from '../icons/FolderIcon';

const propTypes = {
  identity: PropTypes.shape({
    id: PropTypes.string.isRequired,
    selectedAlbums: PropTypes.arrayOf(PropTypes.object).isRequired,
    relationship: PropTypes.string,
  }),
  albumFolderAlbums: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      albumFolder: PropTypes.shape({
        id: PropTypes.string,
      }),
    }),
  ).isRequired,
  selectedAlbumCustomPrintIds: PropTypes.arrayOf(PropTypes.string),
  deselectAlbum: PropTypes.func.isRequired,
  deselectCustomPrint: PropTypes.func.isRequired,
};

const defaultProps = {
  albumFolder: {
    id: '',
    name: '',
    parent: {
      id: '',
    },
  },
};

const DiscoverAlbumFolderSummaryAlbumFolder = ({
  identity,
  albumFolderAlbums,
  selectedAlbumCustomPrintIds,
  deselectAlbum,
  deselectCustomPrint,
}) => {
  const { albumFolder } = albumFolderAlbums[0];

  const renderRemoveButton = onClick => {
    return (
      <Button
        className="ml-2"
        btnStyle="reset"
        onClick={onClick}
        aria-label="Deselect album"
      >
        <TrashIcon color="#fe5851" size={14} />
      </Button>
    );
  };

  const getselectedAlbumCustomPrints = album => {
    return (album?.custom_prints?.records ?? []).filter(albumCustomPrint =>
      selectedAlbumCustomPrintIds.includes(albumCustomPrint.id),
    );
  };

  return (
    <Fragment>
      <div className="pb-1 d-flex align-items-center">
        <FolderIcon color="#0d84fe" size={16} className="mr-1" />
        <span className="text-extra-bold text-dark">{albumFolder.name}</span>
      </div>
      <div key={`${albumFolder.id}-albums`} className="flex-list-item-children">
        {albumFolderAlbums.map(album => {
          const albumCustomPrints = getselectedAlbumCustomPrints(album);

          return (
            <Fragment key={album.id}>
              <div key={album.id} className="pb-1">
                <span className="text-dark text-extra-bold">{album.name}</span>
                {renderRemoveButton(() => deselectAlbum(album, identity))}
              </div>
              {albumCustomPrints.length > 0 && (
                <div className="flex-list-item-children">
                  {albumCustomPrints.map(albumCustomPrint => (
                    <div
                      key={albumCustomPrint.id}
                      className="flex-list-item ml-4"
                    >
                      {renderRemoveButton(() =>
                        deselectCustomPrint(albumCustomPrint, identity.id),
                      )}
                      <span className="text-xs text-dark text-bold">
                        {albumCustomPrint.custom_print.name}
                      </span>
                    </div>
                  ))}
                </div>
              )}
            </Fragment>
          );
        })}
      </div>
    </Fragment>
  );
};

DiscoverAlbumFolderSummaryAlbumFolder.propTypes = propTypes;
DiscoverAlbumFolderSummaryAlbumFolder.defaultProps = defaultProps;

export default DiscoverAlbumFolderSummaryAlbumFolder;
